<template>
	<!-- @vue-expect-error -->
	<div :class="nodeClasses" :id="dataNode.id">
		<div class="inputs">
			<!-- @vue-expect-error -->
			<div
				v-for="(inputArray, inputName) in dataNode.inputs"
				:class="'input ' + inputName + (inputArray.required ? ' input-required' : '')"
			>
				<div class="hidden-label">
					<!-- @vue-expect-error -->
					{{
						dataNode.data.input_labels
							? dataNode.data.input_labels[inputName] || inputName
							: inputName
					}}
				</div>
			</div>
		</div>
		<div class="drawflow_content_node">
			<div>
				<!-- @vue-expect-error -->
				<drawflow-top-right-tags
					:tags-to-show="tagsToShow"
					:modal-id="modalId"
					:parent-instance="this"
				></drawflow-top-right-tags>
			</div>
			<p>
				<span
					class="senaryon-icon senaryon-icon-roles senaryon-icon--with-right-margin"
				></span>
				<span> <!-- @vue-expect-error --> {{ dataNode.data.actor_name }}</span>
			</p>
			<p>
				<span
					class="senaryon-icon senaryon-icon-negotiation senaryon-icon--with-right-margin"
				></span>
				<span>
					<!-- @vue-expect-error --> {{ dataNode.data.article_title }}</span
				>
			</p>
		</div>
		<div class="outputs">
			<!-- @vue-expect-error -->
			<div
				v-for="(outputItem, index) in Object.keys(dataNode.outputs)"
				:class="'output output_' + (index + 1)"
			></div>
		</div>
	</div>
</template>

<script>
import DrawflowHelpers from "./drawflow_helpers";
import DrawflowTopRightTags from "./drawflow_top_right_tags.vue";

export default {
	props: {
		dataNode: Object,
		drawflowInstance: Object,
	},
	components: {
		"drawflow-top-right-tags": DrawflowTopRightTags,
	},
	computed: {
		tagsToShow() {
			return this.drawflowInstance.editor_mode == "edit" ? ["delete"] : [];
		},
		nodeClasses() {
			return `drawflow-node drawflow-node--slim text-center${this.dataNode.data.isCollapsed ? " drawflow-node--collapsed" : ""}`;
		},
	},
	methods: {},
	mounted() {
		// pp.log("mounted drawflow_article_measure_item", this.dataNode);
		// @ts-expect-error
		this.drawflowHelpers = new DrawflowHelpers(this);
		this.drawflowHelpers.addNodeToDrawflowData();
		this.drawflowHelpers.listenForModuleChange(this.drawflowInstance.module);
		pp.vue.bus.$on("DRAWFLOW-node-moved", (data) => {
			if (data.nodeId == this.dataNode.data.child_of) {
				this.drawflowHelpers.redrawConnections();
			}
		});
	},
};
</script>
